<template>
    <div>
        <div class="migrator__wrapper">
            <div class="callout callout-info">
                <p>1
                    Wygląda na to, że Twój jadłospis nie jest kompatybilny z naszym nowym kreatorem.<br>
                    Możesz go przekonwertować, klikając poniższy przycisk.
                </p>
            </div>
            <div>
                <button class="btn btn-success" @click.prevent="migrate" :disabled="inProgress">
                    Kliknij tutaj i poczekaj chwilę

                    <i class="fa fa-chevron-circle-right" v-if="!inProgress"></i>
                    <i class="fa fa-cog fa-spin" v-if="inProgress"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" type="text/scss" scoped>
    .migrator__wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        flex-direction:column;
        > div {
            max-width: 500px;
            font-size: 20px;
        }
    }

    .content-header {
        display:none;
    }

</style>

<script>

  export default {
    props: {
      'route': String,
      'menu': String,
    },
    data() {
      return {
        inProgress: false,
      };
    },
    methods: {
      migrate() {

        this.inProgress = true;

        axios.post(this.route);

        // Echo.private('menu-converted-' + this.menu)
        //   .listen('MenuConvertedEvent', (e) => {
        //     window.location.reload()
        //   });
      },
    },
  };
</script>
